import Widget from "views/logic/widgets/Widget";
import pivotForField from "views/logic/searchtypes/aggregation/PivotGenerator";
import AggregationWidgetConfig from "views/logic/aggregationbuilder/AggregationWidgetConfig";
import AggregationWidget from "views/logic/aggregationbuilder/AggregationWidget";
import Series, { isFunction } from "views/logic/aggregationbuilder/Series";
import { TIMESTAMP_FIELD } from "views/Constants";
import { addWidget } from "views/logic/slices/widgetActions";
import duplicateCommonWidgetSettings from "./DuplicateCommonWidgetSettings";
import { FieldTypes } from "../fieldtypes/FieldType";
const ChartActionHandler = ({ field, contexts: { widget: origWidget = Widget.empty() } }) => (dispatch) => {
  const series = isFunction(field) ? Series.forFunction(field) : Series.forFunction(`avg(${field})`);
  const config = AggregationWidgetConfig.builder().rowPivots([pivotForField(TIMESTAMP_FIELD, FieldTypes.DATE())]).series([series]).visualization("line").rollup(true).build();
  const widgetBuilder = AggregationWidget.builder().newId().config(config);
  const widget = duplicateCommonWidgetSettings(widgetBuilder, origWidget).build();
  return dispatch(addWidget(widget));
};
export default ChartActionHandler;
